import React, { useEffect, useState } from 'react';
import {
  Form, Input, Button, Select, Typography,
  message,
} from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { SubjectType, useTiketsCreate, useTiketsCreateByGuest } from '../../../../hooks/api/tikets';
import { useAuth } from '../../../../store/auth';

import styles from './index.module.scss';

const { TextArea } = Input;
const { Text, Link } = Typography;

const subjectLabels = {
  [SubjectType.SUGGESTION]: 'Suggestion',
  [SubjectType.FEEDBACK]: 'Feedback',
  [SubjectType.COMPLAINT]: 'Complaint',
  [SubjectType.BUG]: 'Bug report',
  [SubjectType.NEW_CATEGORY]: 'Category suggestion',
  [SubjectType.OTHER]: 'Other',
};

function ContactForm(): React.ReactElement {
  const [form] = Form.useForm();
  const [charCount, setCharCount] = useState(1000);
  const { user } = useAuth();
  const tiketsCreate = useTiketsCreate();
  const tiketsCreateByGuest = useTiketsCreateByGuest();

  useEffect(() => {
    if (tiketsCreateByGuest.data?.success) {
      message.success({
        content: 'Message send',
        className: 'custom-success-message',
      });
    }
  }, [tiketsCreateByGuest]);

  function handleMessageChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setCharCount(1000 - e.target.value.length);
  }
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const onFinish = (values: any) => {
    if (user) {
      tiketsCreate.fetch(values).then((res) => {
        if (res) {
          message.success({
            content: 'Message sent successfully',
            className: 'custom-success-message',
          });
          form.resetFields();
        }
      });
    } else {
      tiketsCreateByGuest.fetch(values).then((res) => {
        if (res) {
          message.success({
            content: 'Message sent successfully',
            className: 'custom-success-message',
          });
          form.resetFields();
        }
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Get in Touch</h2>
      <span className={styles.subtitle}>You can reach us anytime</span>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          label="Email*"
          name="email"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Please enter a valid email address' },
          ]}
        >
          <Input placeholder="Type here" style={{ height: 50, borderRadius: 10, fontSize: 17 }} />
        </Form.Item>

        <Form.Item
          label="Subject*"
          name="type"
          rules={[{ required: true, message: 'Please select a subject' }]}
        >
          <Select
            style={{ height: 50 }}
            className={styles.selectInp}
            placeholder="Select Subject"
          >
            {Object.entries(subjectLabels).map(([value, label]) => (
              <Select.Option key={value} value={value}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Message"
          name="description"
          rules={[{ required: true, message: 'Please enter your message' }]}
        >
          <TextArea
            rows={4}
            maxLength={1000}
            placeholder="Type here"
            style={{ borderRadius: 10, fontSize: 17 }}
            // eslint-disable-next-line react/jsx-no-bind
            onChange={handleMessageChange}
          />
        </Form.Item>

        <Text type="secondary">{charCount} characters left</Text>

        <Form.Item style={{ marginTop: 16 }}>
          <Button
            type="primary"
            icon={<SendOutlined />}
            className={styles.sendButton}
            htmlType="submit"
          >
            Send Message
          </Button>
        </Form.Item>

        <span className={styles.disclaimer}>
          By continuing, you agree to our{' '}
          <Link underline target="_blank" href="/terms-and-conditions">User Agreement</Link> <br />
          and acknowledge that you understand the{' '}
          <Link underline target="_blank" href="/privacy-policy">Privacy Policy.</Link>
        </span>
      </Form>
    </div>
  );
}

export default ContactForm;
